import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate} from "react-router-dom";
import { ApiUrl } from "../../../ApiUrl";
import "react-datepicker/dist/react-datepicker.css";
import {  Row, Col, Form } from "react-bootstrap";
import { jsPDF } from "jspdf";
import "jspdf-autotable";

const AdmAttendanceEntry = () => {
  const navigate = useNavigate();
  

  const [formData, setFormData] = useState({
    viewOption: "payment",
    organizationName: "",
    numParticipants: "",
    trainingModule: "",
    academicSession: "",
  });
  const [error, setError] = useState("");
  const [paymentRows, setPaymentRows] = useState([]);
  const [loadingPayments, setLoadingPayments] = useState(true);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    
   if (value === "outstanding") {
     navigate("/student/outstanding-details");
   }
  };

  useEffect(() => {
    const fetchStudentPaymentHeader = async () => {
      const studentId = sessionStorage.getItem("userId");
      const academicYearId = localStorage.getItem("academicSessionId");
      const orgId = localStorage.getItem("orgId") || "";
      const branchId = localStorage.getItem("branchId") || "";

      if (!studentId || !academicYearId) {
        setError("Student session details are missing. Please log in again.");
        setLoadingPayments(false);
        return;
      }

      try {
        setError("");
        const response = await fetch(
          `${ApiUrl.apiurl}STUDENT_PROFILE/GetStudentProfile/${studentId}/?academic_year_id=${academicYearId}`
        );

        const contentType = response.headers.get("content-type") || "";
        const payload = contentType.includes("application/json")
          ? await response.json()
          : null;

        if (!response.ok || !payload || payload.message !== "Success") {
          throw new Error(payload?.message || "Unable to load student details.");
        }

        const student = payload.data || {};
        setFormData((prev) => ({
          ...prev,
          organizationName: student.studentname || "",
          numParticipants: student.classname || "",
          trainingModule: student.sectionname || "",
          academicSession: student.academic_year || "",
        }));

        const queryParams = new URLSearchParams();
        queryParams.append("academic_year_id", academicYearId);
        if (orgId) queryParams.append("org_id", orgId);
        if (branchId) queryParams.append("branch_id", branchId);

        const paymentResponse = await fetch(
          `${ApiUrl.apiurl}STUDENT_PROFILE/GetStudentPaymentHistory/${studentId}/?${queryParams.toString()}`
        );

        const paymentContentType = paymentResponse.headers.get("content-type") || "";
        const paymentPayload = paymentContentType.includes("application/json")
          ? await paymentResponse.json()
          : null;

        if (!paymentResponse.ok || !paymentPayload || paymentPayload.message !== "Success") {
          throw new Error(paymentPayload?.message || "Unable to load payment history.");
        }

        setPaymentRows(Array.isArray(paymentPayload.data) ? paymentPayload.data : []);
      } catch (fetchError) {
        console.error("Error fetching payment gateway student details:", fetchError);
        setError(fetchError.message || "Unable to load student details.");
        setPaymentRows([]);
      } finally {
        setLoadingPayments(false);
      }
    };

    fetchStudentPaymentHeader();
  }, []);

  const handleReceiptLinkClick = async (receiptNo) => {
    const academicSessionId = localStorage.getItem("academicSessionId");

    if (!academicSessionId) {
      alert("Academic session ID not found.");
      return;
    }

    try {
      const response = await fetch(
        `${ApiUrl.apiurl}FEESRECIPTS/GetFeeReceiptsBasedOnReceiptNo/${receiptNo}/${academicSessionId}`
      );
      const result = await response.json();

      if (response.ok && result.receipt_data) {
        const data = result.receipt_data;
        const doc = new jsPDF("portrait", "mm", "a4");

        const toBase64 = (url) =>
          new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = "Anonymous";
            img.onload = () => {
              const canvas = document.createElement("canvas");
              canvas.width = img.width;
              canvas.height = img.height;
              const ctx = canvas.getContext("2d");
              ctx.drawImage(img, 0, 0);
              resolve(canvas.toDataURL("image/jpeg"));
            };
            img.onerror = (err) => reject(err);
            img.src = url;
          });

        try {
          const sparshLogo = await toBase64("/Assets/sparsh.jpeg");
          doc.addImage(sparshLogo, "JPEG", 10, 10, 20, 20);
        } catch (imageError) {
          console.error("Error adding image:", imageError);
        }

        const pageWidth = doc.internal.pageSize.getWidth();
        doc.setFont("Helvetica", "bold");
        doc.setFontSize(16);
        const headerText = "Sparsh College of Nursing and Allied Sciences";
        const textWidth =
          (doc.getStringUnitWidth(headerText) * doc.internal.getFontSize()) /
          doc.internal.scaleFactor;
        const textX = (pageWidth - textWidth) / 2;
        doc.text(headerText, textX, 22);

        doc.setFontSize(12);
        doc.text("Fee Receipt", pageWidth / 2, 30, { align: "center" });

        const receiptDetails = [
          ["Receipt No", data.receipt_no, "Section", data.sectionname],
          ["Receipt Date", data.receipt_date, "Father's Name", data.fathername],
          ["Student Name", data.studentname, "Fee Period", data.feeperiods],
          ["Admission No", data.admission_no, "Amount", data.amount.toFixed(2)],
          ["Class", data.classname, "", ""],
        ];

        doc.autoTable({
          startY: 35,
          body: receiptDetails,
          theme: "grid",
          styles: { fontSize: 11, fontStyle: "bold" },
          margin: { left: 15 },
          tableWidth: 180,
        });

        const feeElements = Object.values(data.payment_element_list || {}).map(
          (element, index) => [index + 1, element.element_name, element.amount.toFixed(2)]
        );
        feeElements.push(["", "Total", data.amount.toFixed(2)]);

        doc.autoTable({
          startY: doc.lastAutoTable.finalY + 8,
          head: [["Sr. No.", "Element", "Amount"]],
          body: feeElements,
          theme: "grid",
          styles: { fontSize: 11, fontStyle: "bold" },
          columnStyles: { 2: { halign: "right" } },
          margin: { left: 15 },
          tableWidth: 180,
        });

        const paymentData = [
          [data.payment_method, data.payment_reference, data.amount.toFixed(2)],
        ];

        doc.autoTable({
          startY: doc.lastAutoTable.finalY + 8,
          head: [["Payment Method", "Payment Reference", "Amount"]],
          body: paymentData,
          theme: "grid",
          styles: { fontSize: 11, fontStyle: "bold" },
          columnStyles: { 2: { halign: "right" } },
          margin: { left: 15 },
          tableWidth: 180,
        });

        const summary = [
          ["Total Session Fee", data.total_academic_year_fees.toFixed(2)],
          ["Total Paid", data.total_paid.toFixed(2)],
          ["Total Balance", data.remaining_amount.toFixed(2)],
        ];

        doc.autoTable({
          startY: doc.lastAutoTable.finalY + 8,
          body: summary,
          theme: "grid",
          styles: { fontSize: 11, fontStyle: "bold" },
          columnStyles: { 1: { halign: "right" } },
          margin: { left: 15 },
          tableWidth: 180,
        });

        const pdfBlob = doc.output("blob");
        const blobUrl = URL.createObjectURL(pdfBlob);
        window.open(blobUrl, "_blank");
      } else {
        alert(result.message || "Failed to fetch receipt details.");
      }
    } catch (fetchError) {
      console.error("Error fetching receipt details:", fetchError);
      alert("An error occurred. Please try again.");
    }
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-2">
            <div className="card-body">
              <p
                className="text-center fw-bold mb-3"
                style={{ fontSize: "18px" }}
              >
                PAYMENT DETAILS
              </p>

              <div className="row mb-3 mt-3 mx-0">
                <div className="col-12 d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-danger"
                    style={{
                      width: "150px",
                    }}
                    onClick={() => navigate("/student/dashboards")}
                  >
                    Close
                  </button>
                </div>
              </div>

              {error ? <div className="alert alert-danger">{error}</div> : null}

              <div className="row mt-3 mx-2 mt-2">
                <div className="col-12 custom-section-box">
                  <Row className="justify-content-center">
                    <Col
                      className="p-3"
                      xs={12}
                      sm={8}
                      // style={{ border: "1px solid #ccc", borderRadius: "5px" }}
                    >
                      <Form>
                        <Row className="mb-1 mt-4">
                          <Col md={6} className="py-0">
                            <Form.Label className="mb-1">
                              Student Name{" "}
                            </Form.Label>
                          </Col>
                          <Col md={6} className="py-0">
                            <Form.Control
                              type="text"
                              className="form-control form-control-sm detail"
                              name="organizationName"
                              value={formData.organizationName}
                              onChange={handleChange}
                              readOnly
                            />
                          </Col>
                        </Row>
                        <Row className="mb-1">
                          <Col md={6}>
                            <Form.Label>
                              Class<span style={{ color: "red" }}>*</span>
                            </Form.Label>
                          </Col>
                          <Col md={6}>
                            <Form.Control
                              type="text"
                              name="numParticipants"
                              className="form-control detail"
                              value={formData.numParticipants}
                              onChange={handleChange}
                              readOnly
                            />
                          </Col>
                        </Row>

                        <Row className="mb-1">
                          <Col md={6}>
                            <Form.Label>Section</Form.Label>
                          </Col>
                          <Col md={6}>
                            <Form.Control
                              type="text"
                              className="form-control detail"
                              name="trainingModule"
                              value={formData.trainingModule}
                              readOnly
                            />
                          </Col>
                        </Row>

                        {/* <Row className="mb-1">
                          <Col md={6}>
                            <Form.Label>Academic Year </Form.Label>
                          </Col>
                          <Col md={6}>
                            <Form.Control
                              type="text"
                              className="form-control form-control-sm detail"
                              name="trainingModule"
                              value={formData.trainingModule}
                              onChange={handleChange}
                            />
                          </Col>
                        </Row> */}

                        <Row className="mb-1">
                          <Col md={6}>
                            <Form.Label>Academic Session</Form.Label>
                          </Col>
                          <Col md={6}>
                            <Form.Control
                              type="text"
                              className="form-control detail"
                              name="academicSession"
                              value={formData.academicSession}
                              readOnly
                            />
                          </Col>
                        </Row>

                        <Row className="mb-3 mt-5">
                          <Col
                            md={{ span: 7, offset: 7 }}
                            className="d-flex justify-content-end"
                          >
                            <Form.Check
                              type="radio"
                              id="viewOutstanding"
                              label="View Outstanding Details"
                              name="viewOption"
                              value="outstanding"
                              checked={formData.viewOption === "outstanding"}
                              onChange={handleChange}
                              className="me-3"
                            />
                            <Form.Check
                              type="radio"
                              id="viewPayment"
                              label="View Payment Details"
                              name="viewOption"
                              value="payment"
                              checked={formData.viewOption === "payment"}
                              onChange={handleChange}
                            />
                          </Col>
                        </Row>
                      </Form>
                    </Col>
                  </Row>
                </div>
              </div>
              <div className="col-12">
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Semester</th>
                        <th>Receipt Date</th>
                        <th>Receipt Amount</th>
                        <th>Discount Amount</th>
                        <th>Payment Method</th>
                        <th>Receipt</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loadingPayments ? (
                        <tr>
                          <td colSpan="6" className="text-center">
                            Loading payment details...
                          </td>
                        </tr>
                      ) : paymentRows.length > 0 ? (
                        paymentRows.map((receipt) => (
                          <tr key={receipt.id}>
                            <td>{receipt.semester || "-"}</td>
                            <td>{receipt.receipt_date || "-"}</td>
                            <td>{receipt.receipt_amount ?? 0}</td>
                            <td>{receipt.discount_amount ?? 0}</td>
                            <td>{receipt.payment_method || "-"}</td>
                            <td>
                              {receipt.receipt_no ? (
                                <button
                                  type="button"
                                  className="btn btn-link p-0 text-decoration-underline align-baseline"
                                  onClick={() => handleReceiptLinkClick(receipt.receipt_no)}
                                >
                                  RC{receipt.receipt_no}
                                </button>
                              ) : (
                                "-"
                              )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="6" className="text-center">
                            No payment records found for this student
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AdmAttendanceEntry;
